// extracted by mini-css-extract-plugin
export default {"adCarouselCard":"AdCarouselCard_adCarouselCard__hsBj+"};